// extracted by mini-css-extract-plugin
export default {"heading":"Birthday_heading__nEgsX","birthday":"Birthday_birthday__vg9ey","updateButton":"Birthday_updateButton__CHH4o"};